module.exports = __webpack_public_path__ + "img/altfBanner.7981c4a3.svg";